import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({ selector: 'app-configuration-delete-dialog', styleUrls: ['../billing-dialog.scss'], template: `
  <h2 mat-dialog-title>Delete {{ data.kind }}?</h2>
  <mat-dialog-content>
    <p><strong>{{ data.label }}</strong></p>
    <p>This removes the record from active configuration and refreshes the current draft. Partner matching, bundle mapping, or pricing may become unavailable.</p>
    <p>Saved billing versions stay unchanged. The record's history is retained; this is not permanent data erasure.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end"><button mat-button type="button" cdkFocusInitial (click)="ref.close(false)">Cancel</button><button mat-raised-button color="warn" type="button" (click)="ref.close(true)">Delete record</button></mat-dialog-actions>
`, styles: ['p { font-size: 13px; line-height: 1.5; }'] })
export class ConfigurationDeleteDialogComponent {
  constructor(public ref: MatDialogRef<ConfigurationDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { kind: string, label: string }) {}
}
